module.exports = __webpack_public_path__ + "static/media/json_download.fa4cdcd2.svg";